import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.split";
import _slicedToArray from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/slicedToArray";
import pad from "./pad";
/**
 * @param {String} value YYYY-MM format
 * @param {Number} sign -1 or +1
 */

export default (function (value, sign) {
  var _value$split$map = value.split('-').map(Number),
      _value$split$map2 = _slicedToArray(_value$split$map, 2),
      year = _value$split$map2[0],
      month = _value$split$map2[1];

  if (month + sign === 0) {
    return "".concat(year - 1, "-12");
  } else if (month + sign === 13) {
    return "".concat(year + 1, "-01");
  } else {
    return "".concat(year, "-").concat(pad(month + sign));
  }
});